import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

export const Loading: React.FC = () => {
  return (
    <div className='vh-100 flex align-items-center justify-content-center bg-dark'>
      <CircularProgress sx={{ color: 'var(--royal-gold)' }} size={60} />
    </div>
  );
};
